<div class="ai-token-modal">
  <div class="logo-container">
    <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" class="main-logo" width="200">
  </div>

  <h2 class="modal-title">Failure</h2>

  <p class="description text-center">
    Email sent to Support. Try again later.
  </p>

  <div class="btn-wrapper">
    <button type="button" class="btn btn-theme" (click)="closeModal()">Close</button>
  </div>
</div>
